/* ALOURA — cohérence visuelle, disponibilité et liens légaux — audit 11 sept 2026 */
(function () {
  'use strict';

  function setCardImage(card, url, alt) {
    if (!card || !url) return;
    var img = card.querySelector('img');
    if (!img) return;
    img.src = url;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.alt = alt || '';
  }

  function fixHomeCollections() {
    var mosaic = document.querySelectorAll('.an-mosaic-card');
    var categories = [
      { title: 'Lampes à poser', url: 'https://cdn.shopify.com/s/files/1/1043/7653/3334/collections/lampe-a-poser-rotin-bambou-natsu-env1.png?v=1789134590', alt: 'Lampe à poser NATSU – collection Lampes à poser ALOURA' },
      { title: 'Lampes de chevet', url: 'https://cdn.shopify.com/s/files/1/1043/7653/3334/collections/opale-duo-de-lampes-de-chevet-blanches-env1.png?v=1789133578', alt: 'Lampes de chevet OPALE – collection Lampes de chevet ALOURA' },
      { title: 'Suspensions & lustres', url: 'https://cdn.shopify.com/s/files/1/1043/7653/3334/collections/suspension-cristal-ovale-chromee-ou-doree-telecommande-grand-ou-petit--ambiance-1-4k.jpg?v=1789133679', alt: 'Suspension OVALE – collection Suspensions et lustres ALOURA' },
      { title: 'Appliques murales', url: 'https://cdn.shopify.com/s/files/1/1043/7653/3334/collections/applique-murale-halia-diffusion-douce-haut-bas-couloir-chambre-ambiance-1-4k.jpg?v=1789133650', alt: 'Applique murale HALIA – collection Appliques murales ALOURA' }
    ];
    categories.forEach(function (item, index) {
      var card = mosaic[index];
      if (!card) return;
      var h3 = card.querySelector('h3');
      if (h3) h3.textContent = item.title;
      setCardImage(card, item.url, item.alt);
    });

    var rooms = document.querySelectorAll('.an-room-card');
    var roomData = [
      { url: 'https://cdn.shopify.com/s/files/1/1043/7653/3334/collections/lampadaire-dore-royal-abat-jour-lin-structure-noir-or-interrupteur-au--ambiance-1-4k.jpg?v=1789133667', alt: 'Lampadaire ROYAL dans un salon – collection Salon ALOURA' },
      { url: 'https://cdn.shopify.com/s/files/1/1043/7653/3334/collections/lampe-de-chevet-retro-ambre-abat-jour-tissu-rechargeable-usb-c-3-teint-ambiance-1-4k.jpg?v=1789133663', alt: 'Ambiance chambre avec lampe AMBRE – collection Chambre ALOURA' },
      { url: 'https://cdn.shopify.com/s/files/1/1043/7653/3334/collections/suspension-3-globes-verre-bulle-restaure-5.jpg?v=1789133665', alt: 'Suspension BULLE – collection Salle à manger ALOURA' },
      { url: 'https://cdn.shopify.com/s/files/1/1043/7653/3334/collections/applique-rotin-roseau-tressage-artisanal-style-boho-murale-ambiance-1-4k.jpg?v=1789133669', alt: 'Applique ROSEAU – collection Entrée ALOURA' }
    ];
    roomData.forEach(function (item, index) { setCardImage(rooms[index], item.url, item.alt); });
  }

  function makeAvailabilityConservative() {
    var row = document.querySelector('[data-lp5-availability]');
    if (!row) return;
    function normalize() {
      var label = row.querySelector('strong');
      if (label && label.textContent.trim() === 'En stock') label.textContent = 'Disponible à la commande';
    }
    normalize();
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(normalize);
      observer.observe(row, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-lp5-option]')) setTimeout(normalize, 0);
    });
  }

  function fixFooterLegalLinks() {
    var map = {
      'Conditions générales': '/pages/conditions-generales',
      'Confidentialité': '/pages/confidentialite',
      'Politique de remboursement': '/pages/politique-de-remboursement',
      'Mentions légales': '/pages/mentions-legales'
    };
    document.querySelectorAll('.alf__col[aria-label="Informations"] a').forEach(function (link) {
      var label = link.textContent.trim();
      if (map[label]) link.setAttribute('href', map[label]);
    });
  }

  function run() {
    if (document.querySelector('[data-neo-home]')) fixHomeCollections();
    makeAvailabilityConservative();
    fixFooterLegalLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
